import { FC, useState } from 'react';
import { RootState } from '@/reducers';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DataSource, DataSourceCodeConfig, EDataSourceStatus } from '@/models/dataSource';
import { StepPageActions } from '@/global/components';
import { CheckInstallationMessage } from './CheckInstallationMessage';
import { CheckInstallationContent } from './CheckInstallationContent';

type CheckInstallationStepProps = {
  onNextStep?: VoidFunction;
  onPrevStep?: VoidFunction;
  onCancel?: VoidFunction;
};

export const CheckInstallationStep: FC<CheckInstallationStepProps> = ({ onNextStep, onPrevStep }) => {
  const { t } = useTranslation('data_source_edit');

  const dataSource = useSelector((state: RootState) => state.dataSources.edit?.dataSource) as Partial<DataSource<DataSourceCodeConfig>> | undefined;
  const [active, setActive] = useState(dataSource?.status === EDataSourceStatus.ACTIVE);

  return (
    <>
      <CheckInstallationContent dataSource={dataSource} active={active} onActiveComplete={() => setActive(true)} goNextStep={onNextStep} />

      {!active && (
        <div className='flex p-6'>
          <div className='flex-1 text-left'>
            <h1 className='mb-2 text-sm font-bold leading-5 text-gray-900'>{t('code.check_installation.cannot_check_now')}</h1>
            <CheckInstallationMessage text='you_can_continue' />
          </div>

          <StepPageActions
            primaryButton={{
              text: 'data_source_edit.code.check_installation.add_it_anyway',
              onClick: onNextStep,
            }}
            secondaryButton={{
              text: 'COMMON.cancel',
              onClick: onPrevStep,
            }}
          />
        </div>
      )}
    </>
  );
};
